import { css, Global } from '@emotion/react/macro';
import styled from '@emotion/styled/macro';
import { BaseButton, Styles, Variables } from '@enter/core';
import '@mdi/font/css/materialdesignicons.min.css';
import 'katex/dist/katex.min.css';
import React from 'react';

const styles = css`
    ${Styles.Normalize}
    ${Styles.Core}
`;

export const GlobalStyles = () => <Global styles={styles} />;

export const Section = styled.section`
    display: flex;
    height: 100vh;
    flex-direction: column;
    color: ${Variables.Colors.p500};
    background-color: ${Variables.Colors.ghostWhite};
    align-items: center;
`;

export const Anchor = styled.a`
    display: flex;
`;
export const Button = styled(BaseButton)`
    margin-top: 2em;
    width: 100%;
`;
